import { Input, SimpleGrid, VStack } from '@chakra-ui/react'
import InputField from '../../../components/InputField'
import { isValidEmailFormat } from '../../../utils/validation-helpers/emailFormatValidate'
import { FieldErrorsImpl, UseFormRegister } from 'react-hook-form'
import { OrganizationAdminFormData } from '../organizationAdminSlice'
import { trimValue } from '../../../utils/text-formatter'

interface PrescriberFormProps {
  register: UseFormRegister<OrganizationAdminFormData>
  errors: FieldErrorsImpl<OrganizationAdminFormData>
}

export const OrganizationAdminForm = ({ register, errors }: PrescriberFormProps) => {
  return (
    <VStack
      overflow="auto"
      p="24px"
      pb="9"
      minHeight="100%"
      height={'100%'}
      minWidth={'60%'}
      spacing="12"
      alignItems="flex-start"
    >
      <SimpleGrid
        columns={[1, 1]}
        rowGap={6}
        columnGap={20}
        width={'100%'}
        maxWidth="600px"
        alignItems="start"
        justifyItems="start"
        style={{ marginBottom: '36px' }}
      >
        <InputField label="First Name" field="givenName" isRequired={true} errors={errors}>
          <Input
            placeholder="First Name"
            width="100%"
            minWidth="300px"
            {...register('givenName', {
              required: 'Required',
              setValueAs: trimValue,
              maxLength: {
                value: 40,
                message: 'First name must be less than 40 Characters',
              },
              validate: (value?: string) => value?.trim() !== '' || 'First name cannot be empty',
            })}
          />
        </InputField>
        <InputField label="Family Name" field="familyName" isRequired={true} errors={errors}>
          <Input
            placeholder="Family Name"
            width="100%"
            minWidth="300px"
            {...register('familyName', {
              setValueAs: trimValue,
              required: 'Required',
              maxLength: {
                value: 40,
                message: 'Family name must be less than 40 Characters',
              },
              validate: (value?: string) => value?.trim() !== '' || 'Family name cannot be empty',
            })}
          ></Input>
        </InputField>
        <InputField label="Email" field="email" isRequired={true} errors={errors}>
          <Input
            placeholder="example@email.com"
            width="100%"
            minWidth="300px"
            {...register('email', {
              setValueAs: trimValue,
              required: 'Please enter Email for confirmation emails at this prescriber',
              validate: (email?: string) => {
                if (!email || email.trim() === '') {
                  return 'Email cannot be empty'
                }
                if (email.length > 50) {
                  return 'The maximum length of an email is 50'
                }
                return (
                  isValidEmailFormat(email) ||
                  'Please enter email with the correct format, such as example@email.com'
                )
              },
            })}
          ></Input>
        </InputField>
      </SimpleGrid>
    </VStack>
  )
}
